import CityPageTemplate from "../city-template/CityPageTemplate";
import { auroraCoConfig } from "./data";

export default function AuroraCoPage() {
  return <CityPageTemplate config={auroraCoConfig} />;
}